/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React from 'react';
import { formatDateTime } from '../../util/DateUtil';

const makeAddress = (address) => {
  if (!address) {
    return '';
  }

  return (address.street ? address.street : '') +
         (address.extnum ? ' ' + address.extnum : '') +
         (address.intnum ? ' ' + address.intnum : '') +
         (address.locality ? ' ' + address.locality : '')  +
         (address.town ? ' ' + address.town : '')  +
         (address.zip ? ' C.P. ' + address.zip : '');
}

const CardInfo = ({ data }) => {
  const card = [
    {key: "accountType", label: "Tipo de cuenta"},
    {key: "udate", label: "Fecha de estatus", date: true},
    {key: "partner", label: "Partner"},
    {key: "wallet", label: "Wallet ID"},
    // {key: "iteration", label: "Iteración de la tarjeta"},
    // {key: "receivedBy", label: "Recibido por"},
    // {key: "shippingType", label: "Tipo de envío"},
    // {key: "cashin", label: "Referencia cashin"},
  ];
  
  const tracking = [
    {key: "agentName", label: "Agente estatus"},
    {key: "shippingDate", label: "Fecha de envío", date: true},
    {key: "provider", label: "Mensajería"},
    {key: "shippingAddress", label: "Dirección de envío", address: true},
    {key: "deliveryDate", label: "Fecha de entrega"},
    {key: "deliveryStatus", label: "Estatus de entrega"},
    {key: "trackingNumber", label: "Número de guía"},
  ];

  const cancel = [
    {key: "reason", label: "Razón de cancelación"},
    {key: "comment", label: "Comentarios"},
    {key: "agent_info", label: "Agente", agent: true},
  ];

  return (
    <div className="dataBlock">
      {card.map((item) => {
        if(data.card[item.key]){
          return (
            <div className="dataBlockItem" key={item.key}>
              <label className="detailCard">{item.label}</label>
              {item.date ? <p>{formatDateTime(data.card[item.key])}</p> :
                <p>{data.card[item.key]}</p>        
              }
            </div>
          )
        }
      })}

      {data.card.tracking && tracking.map((item) => {
        if(data.card[item.key]){
          return (
            <div className={`dataBlockItem ${data.card.type === 'virtual' ? 'hidden' : ''}`}  key={item.key}>
              <label className="detailCard">{item.label}</label>
              {item.date ? <p>{formatDateTime(data.card.tracking[item.key])}</p> :
                item.address ? <p>{makeAddress(data.card.tracking[item.key])}</p> :
                <p>{data.card.tracking[item.key]}</p>
              }
            </div>
          )
        }
      })}

      {!data.card.tracking && 
      <div className={`dataBlockItem ${data.card.type === 'virtual' ? 'hidden' : ''}`}>
        <label className="detailCard">Número de guía</label>
        <p>{data.card.tracking_number ? data.card.tracking_number : "N/A"}</p>
      </div>}

      {data.card.reasonCancel && cancel.map((item) => {
        if(data.card[item.key]){
          return (
            <div className="dataBlockItem" key={item.key}>
              <label className="detailCard">{item.label}</label>
              {item.agent ? <p>{data.card.reasonCancel.agent_info ? data.card.reasonCancel.agent_info.name : JSON.parse(localStorage.session)['name']}</p> :
                <p>{data.card.reasonCancel[item.key]}</p>
              }
            </div>
          )
        }
      })}
    </div>
  );
}

export default CardInfo;